module.exports = __webpack_public_path__ + "media/images/icons/vehicle-storage-icon-d9c9f63a9c96eafc33b7150f8299b644.png";